import * as Sentry from '@sentry/react'

import { SENTRY_DSN } from '@/config'
import { dropCloudProviderBreadcrumb } from './cloudProviderPrivacy'

Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
  beforeBreadcrumb: dropCloudProviderBreadcrumb,
})
